module.exports = __webpack_public_path__ + "static/img/p4.cd51f7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/hoopstack/p4.jpg
// module id = 3+U7
// module chunks = 0